import { Box, Button, IconButton, Typography } from '@mui/material';

import AddAllergy from '../create';
import ConfirmationModal from '../../../components/shared/ConfirmationModal';

import {
  ArrowLeftIcon,
  DeleteIcon,
  PlusCircleIcon,
} from '../../../components/shared/CustomIcons';

import { IAllergyComponent } from './types';

import MESSAGES from '../../../constants/message';

const AllergyComponent: React.FC<IAllergyComponent> = ({
  isModalOpen,
  isDeleteModalOpen,
  allergies,
  setIsAddModalOpen,
  toggleAddModal,
  toggleDeleteModal,
  setSelectedAllergy,
  handleDeleteAllergy,
  navigateToTasks,
}) => {
  return (
    <Box
      sx={{ bgcolor: 'solitude.main' }}
      className="d-flex flex-column flex-1"
    >
      <Box sx={{ pt: 8, px: 3, pb: 5 }}>
        <IconButton
          data-testid="back"
          aria-label="back"
          sx={{ color: 'text.primary', p: 0, mb: 4 }}
          onClick={navigateToTasks}
        >
          <ArrowLeftIcon sx={{ fontSize: 40 }} />
        </IconButton>
        <Typography variant="h4">{MESSAGES.ALLERGY.LIST.TITLE}</Typography>
      </Box>
      {allergies?.length > 0 && (
        <Box
          sx={{ gap: '1px', mb: 6.75 }}
          className="d-flex flex-column flex-1"
        >
          {allergies?.map((allergy) => (
            <Box
              key={allergy.name}
              sx={{
                minHeight: 128,
                bgcolor: 'common.white',
                px: 3.25,
                py: 2.5,
                justifyContent: 'space-between',
              }}
              className="d-flex flex-row align-items-center rounded-50"
            >
              <Box className="d-flex flex-column justify-content-center">
                <Typography variant="h6" sx={{ mb: 1.25 }}>
                  {allergy.name}
                </Typography>
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  Duration: {allergy?.duration_value} {allergy?.duration_type}
                </Typography>
              </Box>
              <Box>
                <IconButton
                  data-testId="delete-allergy"
                  onClick={() => {
                    toggleDeleteModal();
                    setSelectedAllergy(allergy);
                  }}
                >
                  <DeleteIcon
                    sx={{ width: 24, height: 24, color: 'error.main' }}
                  />
                </IconButton>
              </Box>
            </Box>
          ))}
        </Box>
      )}

      <ConfirmationModal
        isOpen={isDeleteModalOpen}
        message={MESSAGES.ALLERGY.DELETE.CONFIRMATION.MESSAGE}
        confirmButtonText={MESSAGES.ALLERGY.DELETE.CONFIRMATION.CONFIRM_BUTTON}
        cancelButtonText={MESSAGES.ALLERGY.DELETE.CONFIRMATION.CANCEL_BUTTON}
        setIsOpen={toggleDeleteModal}
        onConfirm={handleDeleteAllergy}
      />

      <Box sx={{ px: 3, pb: 6.75, mt: 'auto' }}>
        <Button
          variant="contained"
          color="info"
          size="small"
          fullWidth
          sx={{ py: 2.5, gap: 1 }}
          onClick={toggleAddModal}
          startIcon={<PlusCircleIcon />}
        >
          {MESSAGES.ALLERGY.ADD.BUTTON_TEXT}
        </Button>
      </Box>
      <AddAllergy
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsAddModalOpen}
      />
    </Box>
  );
};

export default AllergyComponent;
